import React from "react";
import "./about.css"
import phto from "../imgs/phto.jpg";
const About = () => {
  return (
    <div className="container" id="about">
      <div className="section">
        <div className="section-title">About EcoWaste</div>
        <div className="content">
          <div className="text-container">
            <div className="section-heading">
              Leading the Way in Sustainable Waste Management
            </div>
            <div className="section-subheading">
              At EcoWaste, we've been pioneering sustainable waste management
              solutions for over two decades. Our commitment to environmental
              stewardship drives everything we do.
            </div>
            <div className="stats">
              <div className="stat">
                <h3>20+</h3>
                <p>Years Experience</p>
              </div>
              <div className="stat">
                <h3>50k+</h3>
                <p>Clients Served</p>
              </div>
              <div className="stat">
                <h3>95%</h3>
                <p>Recycling Rate</p>
              </div>
            </div>
            <div className="features">
              <div className="feature">
                <i className="fas fa-check-circle"></i>
                <div>
                  <h4> Environmental Compliance</h4>
                  <p>
                    Full compliance with all environmental regulations and
                    standards.
                  </p>
                </div>
              </div>
              <div className="feature">
                <i className="fas fa-cogs"></i>
                <div>
                  <h4>Modern Equipment</h4>
                  <p>
                    State-of-the-art fleet and processing facilities for
                    efficient waste management.
                  </p>
                </div>
              </div>
              <div className="feature">
                <i className="fas fa-users"></i>
                <div>
                  <h4>Expert Team</h4>
                  <p>
                    Highly trained professionals dedicated to quality service.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="image-container">
            <img src={phto} alt="Waste Management Facility" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
